export enum CustomerTypeEnum {
  Basic = 'Basic',
  Reseller = 'Reseller',
}
